<div class="modal-popup">
  <form class="transfer-popup-container" [formGroup]="searchForm">
    <p class="title">Transferir fac</p>
    <p class="description">Selecione para quem deseja transferir a fac</p>

    <div class="input-box">
      <input
        type="text"
        id="search-destination-input"
        placeholder="Buscar"
        formControlName="search"
        maxlength="100"
        autocomplete="off"
        (input)="searchInput($event.target.value)"
        (keydown.enter)="autocomp = false"
        (keydown)="downList($event)"
      > 
    </div>

    <div class="search-broker-backdrop" *ngIf="autocomp" (click)="autocomp = false"></div>

    <div class="search-broker-autocomplete" *ngIf="autocomp && autoSearchResults.length > 0">
      <div id="autocomplete-result-{{i}}" class="autocomplete-item" *ngFor="let result of autoSearchResults; let i = index" [ngClass]="{'keyHover': i === autocompIdx}" (pointerover)="pointerSelection(i)" (click)="patchInputValue()">
        <span [innerHTML]=result.match.value></span>
      </div>
    </div>

    <div class="btn-container">
      <lib-button-tertiary id="transfer-btn-cancel" (click)="closeModal.emit(true)">Cancelar</lib-button-tertiary>
      <lib-button-primary id="transfer-btn-confirm" (click)="transferForm.valid ? transferFac() : null" [isDisabled]="transferForm.invalid">Transferir</lib-button-primary>
    </div>
  </form>
</div>
